import { END_POINT } from "constants/apiConstant";
import { apiDelete, apiGet, apiPost } from "../utils/apiUtils";

const {
  QUOTATION_SETTINGS,
  QUOTATION_HSN_DUTY,
  QUOTATION_FX_RATE,
  QUOTATIONS,
} = END_POINT;

// Account quotation settings: { settings, hsn_rates, can_edit }.
export const getQuotationSettingsAPI = () => apiGet(QUOTATION_SETTINGS);

export const saveQuotationSettingsAPI = (payload) =>
  apiPost(QUOTATION_SETTINGS, payload);

// rates: [{ hsn_code, duty_pct, description }]
export const saveHsnRatesAPI = (rates) => apiPost(QUOTATION_HSN_DUTY, { rates });

export const deleteHsnRateAPI = (id) => apiDelete(`${QUOTATION_HSN_DUTY}/${id}`);

export const getFxRateAPI = () => apiGet(QUOTATION_FX_RATE);

export const getQuotationsAPI = (bomId) =>
  apiGet(`${QUOTATIONS}?bom_id=${encodeURIComponent(bomId)}`);

export const getQuotationAPI = (id) => apiGet(`${QUOTATIONS}/${id}`);

export const saveQuotationAPI = (payload) => apiPost(QUOTATIONS, payload);

export const submitQuotationAPI = (id) => apiPost(`${QUOTATIONS}/${id}/submit`);
